import configuration from '../../utilities/configuration';
import QuotaModel from "../../models/quota/QuotaModel";
import OrderModel from "../../models/order/OrderModel";
import * as EffectUtility from "../../utilities/EffectUtility";
import { BaseModel } from 'sjs-base-model';

export async function requestAllQuotas() {
    const endpoint = configuration.apiServer + configuration.apiQuotasPath;
    return EffectUtility.getToModel(QuotaModel, endpoint);
}

export async function addQuota(quota) {
    const endpoint = configuration.apiServer + configuration.apiQuotasPath;
    return EffectUtility.postToModel(BaseModel, endpoint, quota);
}

export async function requestQuota(id) {
    const endpoint = configuration.apiServer + configuration.apiQuotasPath + "/" + id;
    return EffectUtility.getToModel(QuotaModel, endpoint);
}

export async function updateQuota(id, quota) {
    const endpoint = configuration.apiServer + configuration.apiQuotasPath + "/" + id;
    return EffectUtility.putToModel(BaseModel, endpoint, quota);
}

export async function deleteQuote(id) {
    const endpoint = configuration.apiServer + configuration.apiQuotasPath + "/" + id;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

export async function requestQuotaOrders(id) {
    const endpoint = configuration.apiServer + configuration.apiQuotasPath + "/" + id + "/orders";
    return EffectUtility.getToModel(OrderModel, endpoint);
}

export async function requestUserQuota(userId) {
    const endpoint = configuration.apiServer + configuration.apiUserQuotaPath + "/" + userId;
    return EffectUtility.getToModel(QuotaModel, endpoint);
}

